<style>
  .my-pagination /deep/ .ngx-pagination {
    text-align: center;
  }
</style>
<div class="container">
  <div class="row">
    <div class="col-9">
      <nav aria-label="breadcrumb" class="breadCust">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a routerLink="/corporate/home">Home</a></li>
          <li class="breadcrumb-item">
            <a routerLink="/corporate/bu-segmentation">BU Audience List</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            {{header}} Audience for {{buselected}}
          </li>
        </ol>
      </nav>
    </div>
    <div class="col-3">
      <div  style="justify-content: right">
        <input
          type="button"
          value="{{buselected}}"
          *ngIf="isWrite"
          class="custbtn red-lt-icon"
          routerLink="/corporate/selectbu-segmentation"
        />

      </div>
    </div>

  </div>

</div>

<div class="container" >
  <form class="form-horizontal mt-1" [formGroup]="audForm">
    <div class="row">
      <div class="col-md-10 col-xl-7">

        <div class="card mt-1">

          <div class="card-body">

            <div>
              <label for="audForm">Audience Name <span style="color:red">*</span></label>
              <input type="text" appSpace maxlength="80" formControlName="audname" class="form-control form-control-md"
                     placeholder="Provide Audience Name" [ngClass]="{ 'is-invalid': submitted && f.audname.errors }" required>
              <div *ngIf="submitted && f.audname.errors" class="invalid-feedback">
                <div *ngIf="f.audname.errors.required">Audience Name is required</div>
              </div>
            </div>

            <div>
              <label for="audForm">Audience Description</label>
              <textarea appSpace formControlName="auddesc" maxlength="255" class="form-control form-control-md"></textarea>
            </div>

          </div>

          <div class="card-footer text-center mt-1" *ngIf="status">
            <div class="my_class text-center" *ngIf="isWrite" [ngClass]="status ? 'displayblock' : 'displaynone'">
              <button type="submit" class="custbtn"  (click)="addNewBUAudience()" >Submit</button>
            </div>
          </div>
          <div class="card-footer text-center mt-1" *ngIf="!status">
            <div class="my_class text-center" *ngIf="isEdit" [ngClass]="status ? 'displaynone' : 'displayblock'">
              <button type="submit" class="custbtn"  (click)="updateBUAudience()" >Update</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
